import React from 'react';
import { Box, Typography } from '@mui/material';

import { AgentHubPageDescriptionPart } from '../agentHubNavItems';

type Props = {
  title: string;
  description?: readonly AgentHubPageDescriptionPart[];
};

export const AgentHubPageHeader = ({ title, description }: Props): JSX.Element => (
  <Box
    data-testid="agent-hub-page-header"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      mb: 4,
    }}
  >
    <Typography
      component="h1"
      variant="huge"
      fontWeight="semibold"
      sx={{
        color: 'text.primary',
        display: 'block',
      }}
    >
      {title}
    </Typography>
    {description && description.length > 0 && (
      <Typography
        component="p"
        sx={{
          color: 'text.secondary',
          fontSize: 14,
          lineHeight: '18px',
          m: 0,
        }}
      >
        {description.map((part) => (
          <Box component="span" key={part.text} sx={{ fontWeight: part.emphasized ? 600 : 400 }}>
            {part.text}
          </Box>
        ))}
      </Typography>
    )}
  </Box>
);
